import { render, staticRenderFns } from "./LapifanModal.vue?vue&type=template&id=1753d53b&scoped=true"
import script from "./LapifanModal.vue?vue&type=script&lang=js"
export * from "./LapifanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753d53b",
  null
  
)

export default component.exports